import React, { useEffect, useState } from 'react';
import { formatChinaPhoneNumber } from '../../utils/formatPhoneNumber';

const PhoneNumber = ({areaCode, phoneNumber, userId, renderButton, renderFlash, renderModalCloseX, userProfile, isPrivateProfileModal}) => {
  const [countryCode, setCountryCode] = useState(areaCode)
  const [phoneNumberState, setPhoneNumberState] = useState(phoneNumber)
  const [checked, setChecked] = useState(userProfile.china_phone != "" ? userProfile.public_china_phone_visible : false);
  const handleUnsuccessfulSubmission = () => {
    $('#phone-number-modal').foundation('reveal', 'close');
    window.Cureus.Flash.alert("Must be a valid phone number");
  }

  // Update modal number state when props change
  useEffect(function onPhoneNumberChange() {
    setPhoneNumberState(formatChinaPhoneNumber(phoneNumber));
    setCountryCode(areaCode);
  }, [phoneNumber]);

  const handlePhoneNumberChange = (event) => {
    const formattedNumber = formatChinaPhoneNumber(event.target.value);
    setPhoneNumberState(formattedNumber);
  }

  const validPhoneNumber = () => {
    return phoneNumberState && phoneNumberState.length === 13;
  }
  
  const onClickCheckBox = () => {
    setChecked(!checked);
  }

  const enableButton = () => {
    return validPhoneNumber();
  }

  const sanitizePhoneNumber = () => {
    if (phoneNumberState && phoneNumberState.length > 0) {
      return phoneNumberState.replace(/\D/g,'');
    }
    return "";
  }

  const renderCheckbox = () => {
    return (
      <div className='row'>
        <div className='large-8 columns'>
          <input
            name='phone-number'
            id='phone-checkbox'
            type='checkbox'
            checked={checked}
            onChange={onClickCheckBox}
          />
          <label htmlFor="phone-checkbox">Display my phone number on my public Cureus profile</label>
        </div>
      </div>
    );
  }

  return (
    <div className="reveal-modal medium" id="phone-number-modal" data-reveal {...(isPrivateProfileModal ? {} : { "data-options": "close_on_background_click:false;close_on_esc:false;" })}>
      <div className="modal-body">
        {renderFlash()}
        {renderModalCloseX()}
        <div className="row">
          <div className="large-12 columns">
            <h4>Phone Number</h4>
            <h6 className="reg">Please enter and save your phone number.</h6>
          </div>
        </div>
        <div className="row">
          <div className="large-6 columns phone-number-container">
            <input
              readOnly={true}
              className="country-code-input"
              name="country-code"
              type="text"
              value={`+${countryCode}`}
              onChange={(e) => {
                setCountryCode(e.target.value)
              }}/>
            <input
              name="phone-number"
              type="tel"
              value={phoneNumberState}
              disabled={checked}
              onChange={(event) => handlePhoneNumberChange(event)}
              maxLength={13}
            />
          </div>
        </div>
        {renderCheckbox()}
        <div className="modal-footer">
          {
            renderButton({
              user: { china_phone: `${sanitizePhoneNumber()}`, 
              public_china_phone_visible: checked },
              section: "ChinaPhoneNumberForm",
            }, `/users/${userId}`, handleUnsuccessfulSubmission, enableButton())
          }
        </div>
      </div>
    </div>
  );
};

export default PhoneNumber;